import { Component } from 'react'

function isChunkError(error) {
  const msg = error?.message || ''
  return msg.includes('dynamically imported module') || msg.includes('Failed to fetch') || msg.includes('Importing a module script failed')
}

export class ErrorBoundary extends Component {
  constructor(props) {
    super(props)
    this.state = { error: null }
  }

  static getDerivedStateFromError(error) {
    return { error }
  }

  componentDidCatch(error, info) {
    console.error('[ErrorBoundary]', error, info)
    // Stale deployment — old chunk hashes are gone. Hard reload gets fresh index.html + chunks.
    if (isChunkError(error)) {
      window.location.reload()
    }
  }

  render() {
    if (this.state.error) {
      return (
        <div className="flex flex-col items-center justify-center h-full gap-4 p-8 text-center">
          <div className="w-12 h-12 rounded-2xl bg-red-400/10 flex items-center justify-center">
            <span className="text-red-400 text-xl">!</span>
          </div>
          <div>
            <p className="text-sm font-semibold text-text">Something went wrong</p>
            <p className="text-xs text-text-muted mt-1 max-w-xs">
              {this.state.error?.message || 'An unexpected error occurred.'}
            </p>
          </div>
          <button
            onClick={() => isChunkError(this.state.error) ? window.location.reload() : this.setState({ error: null })}
            className="text-xs font-semibold text-accent hover:underline active:scale-[0.97] transition-transform"
          >
            Try again
          </button>
        </div>
      )
    }
    return this.props.children
  }
}
